export default {"src":"/_next/static/media/logo-side-color.c41704f0.svg","height":123,"width":459,"blurWidth":0,"blurHeight":0};